module.exports = __webpack_public_path__ + "img/user.2cf39b15.svg";